import { createStore } from 'redux';
import Reducers from '../combineReducers';

const store = createStore(Reducers);

export default store;
